import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sb-account-grid',
  templateUrl: './sb-account-grid.component.html',
  styleUrls: ['./sb-account-grid.component.css']
})
export class SbAccountGridComponent implements OnInit {
  title="SB Account List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master-account/sb-account-grid/sb-account-grid.component.ts